var map = {
	"./bg.json": [
		975,
		0
	],
	"./cs.json": [
		976,
		1
	],
	"./da.json": [
		977,
		2
	],
	"./de.json": [
		978,
		3
	],
	"./el.json": [
		979,
		4
	],
	"./en.json": [
		980,
		5
	],
	"./es-ES.json": [
		981,
		6
	],
	"./es-MX.json": [
		982,
		7
	],
	"./fi.json": [
		983,
		8
	],
	"./fr.json": [
		984,
		9
	],
	"./hu.json": [
		985,
		10
	],
	"./it.json": [
		986,
		11
	],
	"./ja.json": [
		987,
		12
	],
	"./ko.json": [
		988,
		13
	],
	"./nb.json": [
		989,
		14
	],
	"./nl.json": [
		990,
		15
	],
	"./pl.json": [
		991,
		16
	],
	"./pt-BR.json": [
		992,
		17
	],
	"./pt-PT.json": [
		993,
		18
	],
	"./ro.json": [
		994,
		19
	],
	"./ru.json": [
		995,
		20
	],
	"./sl.json": [
		996,
		21
	],
	"./sv.json": [
		997,
		22
	],
	"./ta.json": [
		998,
		23
	],
	"./th.json": [
		999,
		24
	],
	"./tr.json": [
		1000,
		25
	],
	"./zh-CN.json": [
		1001,
		26
	],
	"./zh-TW.json": [
		1002,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 967;
module.exports = webpackAsyncContext;